import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IonicModule, LoadingController } from '@ionic/angular';
import { ToastController } from '@ionic/angular';
import { Analysis, BeerProfileRequest, BeerStat, SearchCharacteristicWithType, SearchType, AnalysisItem, LocalCharacteristic, Venue, SimilarBeerRequest, BaseFlavors} from "../../models/models";
import { AnalysisServiceProvider } from '../../providers/analysis-service/analysis-service';
import { LocationServiceProvider } from "../../providers/location-service/location-service";
import { UserDataProvider } from '../../providers/user-data/user-data';
import { BeerServiceProvider } from '../../providers/beer-service/beer-service';
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { AnalysisHolderProvider } from '../../providers/analysis-holder/analysis-holder';
import { RefdataProvider } from '../../providers/refdata/refdata';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage-angular';
import { AppEventService } from '../../app/app-events';
import { SimilarBeersComponent } from '../similar-beers/similar-beers';
import { BeerSpiderComponent } from '../beer-spider/beer-spider';
import { BeerCcComponent } from '../beer-cc/beer-cc';
import { FlavorSliderAnalysisComponent } from '../flavor-slider/flavor-slider-analysis';
import { BeerHiveComponent } from '../beer-hive/beer-hive';
import { BeerIbaComponent } from '../beer-iba/beer-iba';
import { BeerAromasComponent } from '../beer-aromas/beer-aromas';
import { RatingBarComponent } from '../rating-bar/rating-bar';
import { WishlistButtonComponent } from '../wishlist-button/wishlist-button';
import { CommonModule } from '@angular/common';
import { MyNotesComponent } from '../my-notes/my-notes';
import { FormsModule } from '@angular/forms';


/**
 * Generated class for the BeerAnalysisGroupComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'beer-analysis-group',
  templateUrl: 'beer-analysis-group.html',
  styleUrls: ['./beer-analysis-group.scss'],
  standalone: false,
  imports: [
    IonicModule,
    TranslateModule,
    SimilarBeersComponent,
    BeerSpiderComponent,
    BeerCcComponent,
    FlavorSliderAnalysisComponent,
    BeerHiveComponent,
    BeerIbaComponent,
    BeerAromasComponent,
    RatingBarComponent,
    WishlistButtonComponent,
    CommonModule,
    FormsModule,
    MyNotesComponent
  ]
})

export class BeerAnalysisGroupComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

/*
        currentBaseFlavors
      characteristicsKeyNames
      totalexperienceGUIValue
      theBeerID
      wishlistlabel
      groupHeader
      groupSelectorHidden
      currentBottomSectionGroup
      groups
*/

  // which analysis is active
  private currentAnalysisInstance: string = null; // can be "beerhive", "my", "brewer"

  /*
   *  attributes to manage the gui appearance
   */
  groupSelectorHidden: boolean; // show group selector at the bottom of the page
  groups: Array<any>;
  currentBottomSectionGroup: string;

  /*
   *  transport objects to convey data from and to the gui
   */
  theBeerID;

  currentBaseFlavors: BaseFlavors = {
    sweet: 0,
    sour: 0,
    bitter: 0,
    fruity: 0,
    hoppy: 0,
    malty: 0,
    color: 0,
    clarity: 0
  };
  analysisCharacteristics: Array<SearchCharacteristicWithType>;  // Array of typed key/value pairs
  characteristicsKeyNames: Array<string> = undefined;  // only keys, for passing to <beer-aromas> as input
  totalexperience: number;
  totalexperienceGUIValue: number;

  /*
   *  the model: beerID and analysis objects
   *.            sits in beeranalysisHolder
   */

  // translation objects
  groupHeader: string; // will contain the text to show at the bottom "analysed by ..."
  wishlistlabel: string;

  // event subscriptions
  updateBeerhiveViewSubscription;

  constructor(
    private toastController: ToastController,
    private events: AppEventService,
    private analysisService: AnalysisServiceProvider,
    private locationService: LocationServiceProvider,
    private userData: UserDataProvider,
    private beerService: BeerServiceProvider,
    private beerAnalysisHolder: AnalysisHolderProvider,
    private bhutil: BhutilProvider,
    private loadingCtrl: LoadingController,
    private refdata: RefdataProvider,
    private translateService: TranslateService,
    private storage: Storage,
    private el: ElementRef
  ) {
    this.log("constructor called");
    this.initializeValues();

  }
  private initializeValues():void {
    this.wishlistlabel = this.translateService.instant('BEERANALYSIS.WISHLIST') + " +";

    //default slider values
    this.currentBaseFlavors.sweet = -1;
    this.currentBaseFlavors.sour = -1;
    this.currentBaseFlavors.bitter = -1;
    this.currentBaseFlavors.hoppy = -1;
    this.currentBaseFlavors.fruity = -1;
    this.currentBaseFlavors.malty = -1;

    //analysis info
    this.totalexperience = null;
    this.totalexperienceGUIValue = null;

    //subitems for "my"
    this.currentBaseFlavors.color = -1;
    this.currentBaseFlavors.clarity = 1;

    this.updateBottomSectionGroupSentence();
    this.groupSelectorHidden = false;

    this.analysisCharacteristics = [];

    this.currentAnalysisInstance = "beerhive";

  }
/*
  @ViewChild(BeerSpiderComponent) set spider(comp: BeerSpiderComponent) {
    if (comp) {
      this.log('Spider DOM is ready in the subcomponent!');
      comp.updateSpiderSubscription();
    }
  }
*/
  public updateTransferObjectsFromAnalysis(targetAnalysisInstance: string) {
    this.log("updateTransferObjectsFromAnalysis called");
    this.currentAnalysisInstance = targetAnalysisInstance;

    // this.tweakAnalysisBeforeViewing();
    let theBeerID = this.beerAnalysisHolder.getActiveBeer();
    if (theBeerID != this.theBeerID) {
      this.log("theBeerID updated");
      this.theBeerID = theBeerID;
    }

    this.updateCurrentBaseFlavorsTransferObjectFromAnalysis();
    this.updateCharacteristicsTransferObjectFromAnalysis();
    this.updateTotalExperienceTransferObjectFromAnalysis();
    this.updateBottomSectionGroupSentence();
  }
  public updateView(targetAnalysisInstance: string) {
    this.log("updateView called");
    this.wishlistlabel = this.translateService.instant('BEERANALYSIS.WISHLIST') + ' +';

    this.events.publish("beer-detail:update:beer-spider");
    this.updateIBAViewFromAnalysis();
    this.events.publish("beer-detail:update:beer-aromas",this.characteristicsKeyNames);
    this.events.publish("beer-detail:update:rating-bar", { totalexperience: this.totalexperienceGUIValue});

    this.events.publish("beer-detail:update:wishlist-button");
  }

  // determine which group to show after loading the analysesfrom the server
  initialAnalysisInstanceToShow(): string {
    if (this.beerAnalysisHolder.hasAnalysis("beerhive"))
      return "beerhive";
    else
      return "brewer";
  }
  private getCurrentAnalysis() {
    return this.beerAnalysisHolder.getAnalysis(this.currentAnalysisInstance);
  }
  private updateCurrentBaseFlavorsTransferObjectFromAnalysis() {
    this.log("updateCurrentBaseFlavorsFromAnalysis called");
    let currentAnalysis: Analysis = this.getCurrentAnalysis();
    this.currentBaseFlavors.sweet = this.getRounded(currentAnalysis.sweet.valueOf());
    this.currentBaseFlavors.sour = this.getRounded(currentAnalysis.sour.valueOf());
    this.currentBaseFlavors.bitter = this.getRounded(currentAnalysis.bitter.valueOf());
    this.currentBaseFlavors.hoppy = this.getRounded(currentAnalysis.hoppy.valueOf());
    this.currentBaseFlavors.fruity = this.getRounded(currentAnalysis.fruity.valueOf());
    this.currentBaseFlavors.malty = this.getRounded(currentAnalysis.malty.valueOf());
    this.currentBaseFlavors.color = currentAnalysis.colour.valueOf();

  }

  private updateCharacteristicsTransferObjectFromAnalysis() {
    let currentAnalysis: Analysis = this.getCurrentAnalysis();
    this.log("updateCharacteristicsTransferObjectFromAnalysis called");

    let characteristics = [];

    if (currentAnalysis.characteristicsvalues) {
      for (let aChar of currentAnalysis.characteristicsvalues) {
        let charIndex = aChar.name.indexOf("_");//used to be aChar.indexOf()???
        if (charIndex != -1) {
          // there is an _ in the item name => aroma, ...
          // check for value (do not add if value == 0) => this means the item still has to be removed
          if (aChar.value > 0) {
            // fix for bug BEERHIVE-95 ???
            this.log("updateCharacteristicsFromAnalysis: ADDing " + aChar.name);
            characteristics.push(aChar.name);
          }
          else {
            // not adding this item
            this.log("updateCharacteristicsFromAnalysis: NOT adding " + aChar.name);
          }
        }
        else {
          characteristics.push(aChar.name);
        }
      }
      this.log("updateCharacteristicsFromAnalysis - characteristics are: " + characteristics.join(","));
    }
    this.characteristicsKeyNames = characteristics;

  }
  private updateTotalExperienceTransferObjectFromAnalysis() {
    this.log("updateTotalExperienceTransferObjectFromAnalysis called");
    let currentAnalysis: Analysis = this.getCurrentAnalysis();
      this.totalexperience = currentAnalysis.totalexperience.valueOf();
      if (this.totalexperience > 0)
        this.totalexperienceGUIValue = this.getRounded(2 * this.totalexperience);
      else
        this.totalexperienceGUIValue = 0;
    

  }

  ionViewWillEnter() {
    this.log("ionViewWillEnter called");
  }
  ngOnInit() {
    // setting last caller page
    this.log("ngOnInit called");
    if (this.beerAnalysisHolder.hasActiveBeer()) {
      this.log("ngOnInit: active beer, updating model");
      this.updateTransferObjectsFromAnalysis("beerhive");
    }
    this.updateBeerhiveViewSubscription = () => {
      this.log("updateBeerhiveViewSubscription called");
      this.updateTransferObjectsFromAnalysis("beerhive");
      this.updateView("beerhive");
    }
    this.events.subscribe("beer-analysis:show:beer-analysis-group", this.updateBeerhiveViewSubscription);
  }
  ngAfterViewInit() {
    this.log("ngAfterViewInit called");
    if (this.beerAnalysisHolder.hasActiveBeer()) {
      this.log("ngAfterViewInit: active beer, updating view");
      this.updateTransferObjectsFromAnalysis("beerhive");
      this.updateView(this.currentAnalysisInstance);
    }
    else {
      this.log("ngAfterViewInit: no active beer, not updating view");
    }
  }
  ngOnChanges() {
    this.log("ngOnChanges called");
//    this.updateView(this.currentAnalysisInstance);
  }

  ngOnDestroy(): void {
    this.log("ngOnDestroy called");
    this.initializeValues();
    this.events.unsubscribe("beer-analysis:show:beer-analysis-group", this.updateBeerhiveViewSubscription);
  }

  getRounded(input: number): number {
    let output = Math.round(input);
    return output;
  }

  private tweakAnalysisBeforeViewing() {
    //fix for bug (1) from BEERHIVE-97
    let currentAnalysis: Analysis = this.getCurrentAnalysis();
    if (currentAnalysis.characteristicsvalues !== undefined) {
      for (let theItem of currentAnalysis.characteristicsvalues) {
        let k = theItem.name;
        let v = theItem.value;
        //debugger;
        if (k === "intensity") {
          //iValue = v;
          currentAnalysis.intensity = v;
        }
        else if (k === "body") {
          //bValue = v;
          currentAnalysis.body = v;
        }
        else if (k === "astringent" || k === "astringency") {
          // should have been astringent, not astringency (reopened BEERHIVE-92 in 1.0.7)
          //aValue = v;
          currentAnalysis.astringent = v;
        }
        else if (k === "alcohol") {
          //bValue = v;
          currentAnalysis.alcohol = v;
        }
        else if (k === "carbonation") {
          //aValue = v;
          currentAnalysis.carbonation = v;
        }
      }
    }
  }

  getInstanceNameFromBeerStatGroupName(groupName: string): string {
    switch (groupName) {
      case "Beerhive": return "beerhive";
      case "Brewery": return "brewer";
      default: throw new Error("getInstanceNameFromBeerStatGroupName: invalid group name: " + groupName);
    }
  }

  //reload the list of group names
  reloadGroups() {
    //debugger;
    this.log("reloadGroups called");

    // populate the dropdown
    this.groups = [];

    let beerhiveAdded = false;
    let beerStats = this.beerAnalysisHolder.getBeerStats()
    for (let statsIndex in beerStats) {
      let beerStat: BeerStat = beerStats[statsIndex];
      let groupName = beerStat.groupname;
      if (this.beerAnalysisHolder.hasAnalysis(this.getInstanceNameFromBeerStatGroupName(beerStat.groupname))) {
        this.groups.push(groupName);
        if (beerStat.groupname == "Beerhive")
          beerhiveAdded = true;
      }
    }

    // Stay on the current group if possible
    if (!this.groups.includes(this.currentBottomSectionGroup)) {
      if (beerhiveAdded) {
        this.currentBottomSectionGroup = "Beerhive";
      }
    }

    // if there is a currentBottomSectionGroup, show it
    if (this.currentBottomSectionGroup != null) {
      this.groupSelectorHidden = false;
    }
    else {
      this.groupSelectorHidden = true;
    }
    // update the accompanying text
    this.updateBottomSectionGroupSentence();
  }

  private updateBottomSectionGroupSentence() {
    this.log("updateBottomSectionGroupSentence called");
    switch (this.currentBottomSectionGroup) {
      case "Brewery":
        this.translateService.get('BEERANALYSIS.ANALYSED_BY').subscribe((res: string) => {
          this.groupHeader = res.toLowerCase();
        });
        break;
      case "Beerhive":
        let count = this.getStatsForGroup();
        this.translateService.get('BEERANALYSIS.ANALYSED_BY_GROUP').subscribe((res: string) => {
          this.groupHeader = count + " x " + res.toLowerCase();
        });
        break;
      case "my":
      default:
        this.groupHeader = "";
    }
  }
  private getStatsForGroup(): number {
    this.log("getStatsForGroup called");
    if (!this.currentBottomSectionGroup || this.currentBottomSectionGroup == null) {
      return 0;
    }
    let beerStats = this.beerAnalysisHolder.getBeerStats();
    if (beerStats === undefined || beerStats === null) {
      return -1;
    }
    for (let statsKey in beerStats) {
      let beerStat: BeerStat = this.beerAnalysisHolder.getBeerStats()[statsKey];
      if (beerStat.groupname === "Beerhive" && this.currentBottomSectionGroup === "Beerhive") {
        return beerStat.nbrofanalyses;
      }
      else if (beerStat.groupname === "brewerAnalysis" && this.currentBottomSectionGroup === "Brewery") {
        return beerStat.nbrofanalyses;
      }
    }
    return -1;
  }
  // change the current analysis to the group that comes in
  groupChange(newGroup: string) {
    this.log("groupChange called");
    let targetAnalysisInstance: string = this.getInstanceNameFromBeerStatGroupName(newGroup);

    // change the internal state
    this.updateTransferObjectsFromAnalysis(targetAnalysisInstance);

    // update the view
    this.updateView(this.currentAnalysisInstance);
  }
  private updateIBAViewFromAnalysis() {
    this.log("updateIBAViewFromAnalysis called");
    let currentAnalysis: Analysis = this.getCurrentAnalysis();
    let intensity = (currentAnalysis.intensity === undefined) ? 0 : this.getRounded(currentAnalysis.intensity.valueOf());
    let body = (currentAnalysis.body === undefined) ? 0 : this.getRounded(currentAnalysis.body.valueOf());
    let astringency = (currentAnalysis.astringent === undefined) ? 0 : this.getRounded(currentAnalysis.astringent.valueOf());

    let ibaEvent = {
      "intensity": intensity,
      "body": body,
      "astringency": astringency
    };
    this.events.publish("beer-detail:update:beer-iba", ibaEvent);
  }

  translatedGroup(group: string) {
    let groupId = 'GROUPS.' + group.toUpperCase();
    let translatedGroup = this.translateService.instant(groupId);
    if (groupId === translatedGroup) {
      return group;
    } else {
      return translatedGroup;
    }
  }
  private log(s): void {
    console.log("[beer-analysis-group]" + s);
  }

}
